import { useMutation, useQueryClient } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";
import { medicalExaminationQueryKeys } from "./queryKeys";

export const useDeleteMedicalExaminationFactorMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(MedicalExaminationService.deleteFactor, {
    onSuccess: () => {
      queryClient.invalidateQueries(medicalExaminationQueryKeys.all);
    },
  });
};
